
import { defineComponent, PropType, ref, watch } from 'vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import EditableBlock from '@/components/EditableBlock.vue'
import { Tenant } from '@/pages/Settings/components/editors/TenantConfigEditor.vue'
import CountryDictionary from '@/constants/country_iso_dict'
import Tooltip from '@/components/Tooltip.vue'
import EditableBlockSelect from '@/components/EditableBlockSelect.vue'

export default defineComponent({
  name: 'CompanyAddress',
  components: { EditableBlockSelect, Tooltip, EditableBlock, EditableBlockInput },
  emits: ['update:company-address'],
  props: {
    tenant: {
      type: Object as PropType<Tenant>,
    }
  },

  setup (props) {
    const companyAddress = ref(props.tenant?.settings?.company?.address ?? {})
    let countryDictionaryOptions: string[] = CountryDictionary.map(country => country.name)

    const filterFn = (val, update) => {
      if (val === '') {
        update(() => {
          countryDictionaryOptions = CountryDictionary.map(country => country.name)
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        countryDictionaryOptions = CountryDictionary.map(country => country.name).filter(
          v => v.toLowerCase().indexOf(needle) > -1
        )
      })
    }

    watch(() => props.tenant, () => {
      companyAddress.value = props.tenant?.settings?.company?.address ?? {}
    })

    return {
      companyAddress,
      countryDictionaryOptions,
      filterFn,
    }
  }
})
